import { Card, CardBody, Col, Table } from "reactstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
 import OrganizationAccountBody from "./organizationAccountBodyData";
import CommonCardHeader from "../../../common-elements/common-card-header/CommonCardHeader";

const OrganizationAccounts = () => {
  const [showCount, setShowCount] = useState(4);
  const navigate = useNavigate();

  const handleDropdownAction = (action: string) => {
    switch (action) {
      case "This Week":
        setShowCount(6);  
        break;
      case "This Month":
        setShowCount(9);  
        break;
      case "View All":
        navigate(`${process.env.PUBLIC_URL}/MasterData/organization`);
        break;
      default:
        break;
    }
  };

  return (
    <Col sm="12" lg="8" className='m-0'>
      <Card>
        <CommonCardHeader
          headClass="pb-4"
          title="Recent Accounts"
          mainTitle={true}
          firstItem="This Week"
          secondItem="This Month"
          thirdItem="View All"
          onDropdownAction={handleDropdownAction}
        />
        <CardBody className="pt-0 recent">
          <div className="custom-scrollbar table-responsive">
            <Table className="display" >
              <thead>
                <tr>
                  <th>Account Name</th>
                  <th>ID</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                <OrganizationAccountBody showCount={showCount} />
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrganizationAccounts;